import React, { useMemo, useEffect, useState } from "react";
import moment from "moment";
import TableContainer from "./TableContainer";
import PatientLoader from "../../../common/PatientLoader";
import "./PatientDataTableStyles.css";
import RiskPill from "../../../common/RiskPill";
import { getFullName, getInitials } from "../../../../util/helpers";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";

const InvitedPatientTable = ({ currentUrl, flag }) => {
  let navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [localLoading, setLocalLoading] = useState(false);
  const {
    loading,
    patientData,
    newPatient,
    bhiPatient,
    invitedPatient,
    inActivePatient,
  } = useSelector((state) => state.patient);
  const [status, setStatus] = useState();
  const [filterData, setFilteredData] = useState([]);

  const handleBifurcation = () => {
    const handleFiltering = (data, bhi = false) => {
      let filteredData = JSON.parse(JSON.stringify(data));
      if (flag) {
        filteredData = filteredData.filter((item) => {
          let temp = item.flag || "";
          if (temp.toLowerCase() === flag) {
            return item;
          }
        });
      }

      if (bhi) {
        filteredData = filteredData.filter((item) => {
          const bhiEligible = JSON.parse(item?.bhi_eligible);
          const bhiEnrolled = JSON.parse(item?.bhi_enabled);
          if (bhiEligible && !bhiEnrolled) {
            return item;
          }
        });
      }

      return filteredData;
    };

    if (currentUrl === "all") {
      if (flag) {
        const temp = handleFiltering(patientData);
        setFilteredData(temp);
      } else {
        setFilteredData(patientData);
      }
    } else if (currentUrl === "new") {
      if (flag) {
        const temp = handleFiltering(newPatient);
        setFilteredData(temp);
      } else {
        setFilteredData(newPatient);
      }
    } else if (currentUrl === "bhi") {
      if (flag) {
        const temp = handleFiltering(bhiPatient);
        setFilteredData(temp);
      } else {
        if (status === "eligible") {
          const temp = handleFiltering(patientData, true);
          setFilteredData(temp);
        } else {
          setFilteredData(bhiPatient);
        }
      }
    } else if (currentUrl === "inactive") {
      if (flag) {
        const temp = handleFiltering(inActivePatient);
        setFilteredData(temp);
      } else {
        setFilteredData(inActivePatient);
      }
    } else if (currentUrl === "invited") {
      if (flag) {
        const temp = handleFiltering(invitedPatient);
        setFilteredData(temp);
      } else {
        setFilteredData(invitedPatient);
      }
    }
  };

  useEffect(() => {
    const tempCurrentUrl = window.location.pathname
      .split("/patients/")[1]
      .replace("/", "");
    const tempStatus = searchParams.get("status");
    if (tempCurrentUrl === "bhi" && tempStatus !== null) {
      setStatus(tempStatus);
    }
  }, [searchParams]);

  useEffect(() => {
    setLocalLoading(true);
    if (loading) return;
    handleBifurcation();
    setLocalLoading(false);
  }, [currentUrl, status, loading]);

  useEffect(() => {
    handleBifurcation();
  }, [patientData, newPatient, bhiPatient, invitedPatient, inActivePatient]);

  let renderColumns = [
    {
      Header: "Name",
      accessor: (d) => getFullName(d),
      Cell: ({ cell }) => {
        return (
          <span style={{ textTransform: "capitalize" }}>
            <img
              alt="User's avatar"
              style={{ height: "40px", borderRadius: "100%" }}
              src={`https://placehold.co/70x70/f1f1f5/395E9D/?text=${getInitials(
                cell.value
              )}`}
            />
            &nbsp;&nbsp;{cell.value}
          </span>
        );
      },
    },
    {
      Header: "Status",
      accessor: "flag",
      Cell: ({ cell }) => {
        return (
          <RiskPill
            styles={{ width: "fit-content", gap: "5px" }}
            type={cell.value}
          />
        );
      },
    },
    {
      Header: "BHI Status",
      accessor: (d) => `${d?.bhi_enabled}||${d?.bhi_eligible}`,
      Cell: ({ cell }) => {
        let temp = cell.value.split("||");
        let bhi_enabled = false;
        let bhi_eligible = false;
        if (temp[0] !== "undefined" && temp[1] !== "undefined") {
          bhi_enabled = JSON.parse(temp[0]);
          bhi_eligible = JSON.parse(temp[1]);
        }

        let value = "not eligible";
        if (bhi_eligible) {
          if (bhi_enabled) {
            value = "enrolled";
          } else {
            value = "eligible";
          }
        }
        return (
          <RiskPill
            styles={{ width: "fit-content", gap: "5px" }}
            type={value}
            show_icon={false}
          />
        );
      },
    },
    {
      Header: "Date Joined",
      accessor: "invite_datetime",
      //disableSortBy: true,
      sortType: (a, b) => {
        if (a === null || a === undefined || a === "" || a === "Not Available")
          return 1; // place null values at the bottom
        if (b === null || b === undefined || b === "" || b === "Not Available")
          return -1;
        return (
          new Date(b?.values?.invite_datetime) -
          new Date(a?.values?.invite_datetime)
        );
      },

      Cell: ({ cell }) => {
        return (
          <span style={{ textTransform: "capitalize" }}>
            {cell.value
              ? moment(cell.value).format("MMM Do YYYY, h:mma")
              : "Not Available"}
          </span>
        );
      },
    },
    {
      Header: "Physician",
      accessor: "physician",
      Cell: ({ cell }) => {
        return (
          <span style={{ textTransform: "capitalize" }}>
            {cell.value ? cell.value : "Not Available"}
          </span>
        );
      },
    },
    {
      Header: "Cell Number",
      accessor: "cell_number",
      disableSortBy: true,
      Cell: ({ cell }) => {
        return (
          <span style={{ textTransform: "capitalize" }}>
            {cell.value ? cell.value : "Not Added"}
          </span>
        );
      },
    },
  ];
  if (currentUrl === "invited") {
    renderColumns.pop();
  }

  const columns = useMemo(() => renderColumns, [localLoading]);
  return (
    <>
      {localLoading ? (
        <PatientLoader />
      ) : (
        <TableContainer
          columns={columns}
          data={filterData}
          currentUrl={currentUrl}
          flag={flag}
          loading={localLoading}
          type="invited"
        />
      )}
    </>
  );
};

export default InvitedPatientTable;
